
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return require("private-next-pages/faq.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq"])
      });
    }
  